// extracted by mini-css-extract-plugin
export var resourceCardButton = "resourceFeaturedCard-module--resourceCardButton--e406e";
export var resourceFeaturedCard = "resourceFeaturedCard-module--resourceFeaturedCard--22104";
export var resourceFeaturedCardType = "resourceFeaturedCard-module--resourceFeaturedCardType--784b9";